import { createApp } from 'vue';
import VueClickAway from 'vue3-click-away';
import DealDashboard from './Dashboard.vue';

export const initDealDashboard = () => {
  if (!document.getElementById('deal-dashboard-app')) {
    return;
  }

  const app = createApp(DealDashboard);

  app.config.globalProperties.$companyName = window.COMPANY_NAME;

  app.use(VueClickAway);
  app.mount('#deal-dashboard-app');
};
